<template>
    <footer class="container" id="footer">
        <ul class="nav">
            <li class="nav-item">
                <a class="nav-link" href="/agb" rel="noopener" target="_blank">
                    AGB
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="/impressum" rel="noopener" target="_blank">
                    Impressum
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="/datenschutz" rel="noopener" target="_blank">
                    Datenschutz
                </a>
            </li>
        </ul>
    </footer>
</template>

<script>
    export default {
        name: 'Footer'
    }
</script>

<style lang="scss" scoped>
    @import "../styles/_variables.scss";

    #footer {
        background-color: $footer-background-color;
        border-top-left-radius: $footer-border-radius;
        border-top-right-radius: $footer-border-radius;
        color: $footer-color;
        padding: .75rem 1.25rem;
        position: relative;

        .nav {
            justify-content: space-around;

            .nav-link {
                color: inherit;
            }
        }
    }

    @media (max-width: 575.98px) {
        #footer {
            .nav {
                flex-direction: column;

                .nav-link {
                    text-align: center;
                }
            }
        }
    }
</style>
